













































































































































































































import { cloneDeep } from 'lodash';

import { LowElement, LowElementAction } from '@/types/Element';
import { Component, Vue, Provide, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

import components from '../common'
import { generateUUID } from '@/utils';

// action components
import GlobalActionFetch from './components/GlobalActionFetch.vue';
import GlobalActionDialog from './components/GlobalActionDialog.vue';

let initLinkOptionsWatchTimer = -1;
let currentWatchTimer = -1;


@Component({
  name: 'low-actions',
  components: {
    'action-fetch': GlobalActionFetch,
    'action-dialog': GlobalActionDialog
  }
})
export default class LowActions extends Vue {

  @Getter('current', { namespace: 'page' })
  current?: LowElement;

  @Getter('flatElements', { namespace: 'page' })
  flatElements?: LowElement[];

  @State('elements', { namespace: 'page' })
  elements?: LowElement;

  @State('globalActions')
  actions?: any;

  get actionsKeys () {
    return Object.keys(this.actions || {});
  }

  get actionsValues () {
    return Object.values(this.actions || {});
  }

  visible = false;

  options: any[] = [];

  get optionalOptions () {
    const actions = this.current?.actions;
    if (!actions) {
      return this.options;
    }
    if ((this.form as any).key) {
      return this.options;
    }
    return this.options.filter(item => {
      return !actions.find(action => action.event === item.key)
    });
  }

  form = {
    name: '',
    event: '',
    handle: [
      {
        name: '',
        link: [],
      }
    ]
  };

  rules: any = {
    event: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
    name: [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    handle: [
      { type: 'array', required: true, message: '至少有一个具体动作', trigger: 'change' }
    ],
  };

  linkOptions: any[] = [];

  @Watch('actions', { deep: true })
  flatElementsWatch () {

    clearTimeout(initLinkOptionsWatchTimer);
    initLinkOptionsWatchTimer = setTimeout(() => {
      this.initLinkOptions();
    }, 300);
  }

  @Watch('current')
  currentWatch () {
    clearTimeout(currentWatchTimer);
    currentWatchTimer = setTimeout(() => {
      this.initActionOptions();
    }, 300);
  }

  created () {
    this.initLinkOptions();
    this.initActionOptions();
  }

  initActionOptions () {
    const element = this.current?.element;
    if (!element) return;
    const component = components.find(item => item.name === element)
    if (!component) return;
    this.options = (component.component.actioOptions || []).filter((item: any) => {
      return !item.beIncluded || this.hasElementExistParentsByElement(item.beIncluded)
    });
  }

  initLinkOptions () {
    if (this.flatElements) {

      const elementActions: any = cloneDeep(this.flatElements).filter(item => item.actions && item.actions.length).map((item: any) => {
        item.value = item.id;
        item.label = item.element;
        item.children = (item.actions || []).map((item: any) => {
          item.label = item.name;
          item.value = item.key;
          return item;
        });
        return item;
      });
      const globalActions: any = cloneDeep(this.actionsKeys).map((key: string) => {
        const item = this.actions[key];
        item.value = key;
        item.label = item.name;
        item.children = (item.actions || []).map((item: any) => {
          item.label = item.name;
          item.value = item.key;
          return item;
        });
        return item;
      });

      this.linkOptions = [{
        label: "全局",
        value: 'global',
        children: globalActions || []
      }, {
        label: "元素",
        value: 'element',
        children: elementActions
      }];
    }
  }
  handleCreateAction () {

    this.form = {
      name: '',
      event: '',
      handle: [
        {
          name: '',
          link: []
        }
      ]
    };
    this.$nextTick(() => {
      if (!this.optionalOptions.length) {
        this.$message.warning('组件上没有可用的动作了');
        return;
      }
      this.visible = true;
    });
  }
  handleSaveOrEdit () {
    (this.$refs['form'] as any).validate((valid: boolean) => {
      if (!valid) return false;
      const form = cloneDeep(this.form as any);
      if (!form.handle || !form.handle.length) {
        return this.$message.warning("至少要添加一个具体动作");
      }
      const isEdit = form.key;
      if (!form.key) {
        form.key = generateUUID();
      }
      form.handle = form.handle.map((item: any) => {
        const [type, namespace, key] = item.link;
        item.link = `${type}_${namespace}.${key}`;
        if (!item.key) {
          item.key = generateUUID();
        }
        return item;
      });
      const actions: LowElementAction = form;
      if (this.current) {
        if (!this.current.actions) {
          this.current.actions = [];
        }
        if (isEdit) {
          const index = this.current.actions.findIndex((item) => item.key === form.key);
          this.current.actions.splice(index, 1, actions);
        } else {
          this.current.actions.push(actions);
        }
      }
      this.visible = false;
    });
  }

  handleEditAction (action: any) {
    const cloneAction = cloneDeep(action);

    cloneAction.handle = cloneAction.handle.map((item: any) => {
      const [location, key] = item.link.split('.');
      const [type, namespace] = location.split('_');
      item.link = [type, namespace, key];
      return item;
    });

    this.form = cloneAction;
    this.visible = true;
  }

  handleRemoveAction (action: any) {
    if (!this.current) return;
    const index = this.current?.actions?.findIndex(item => {
      return item.key === action.key;
    });
    if (typeof index === 'undefined') return;

    this.current?.actions?.splice(index, 1);
  }

  handleRemoveActionHandle (index: number) {
    console.log('index', index);
    // this.current?.actions?.splice(index, 1);
    this.form.handle.splice(index, 1);
  }

  handleClose () {
    this.$store.commit("page/SET_CURRENT", undefined);
  }

  hasElementExistParentsByElement (element: string) {
    const current = this.current;
    if (!current) return false;

    const find = (list: any[], id: string) => {
      let resList: any[] = [];
      list.forEach(item => {
        if (item.children && item.children.length) {
          const res = find(item.children, id);
          if (res && res.length) {
            resList.push(item, ...res);
          }
        }
        if (item.id === id) {
          resList.push(item);
        }
      });

      return resList;
    };
    const id = current.id;

    const chainList = find(this.elements?.children || [], id);
    // 去掉当前的元素
    chainList.pop();
    const is = chainList.find(item => item.element === element);
    return is;
  }
}
